module.exports = __webpack_public_path__ + "img/xpu-ha-hotel-2.8744b880.jpg";